import React, { useEffect } from 'react';
import { title } from '../../constants/heads';
import { State } from "../../@types/reducer";
import { useSelector } from "react-redux";
// import { decrypted } from "../../utils/rsa";
import { NextPage, NextPageContext } from "next";
import { getItemUrl } from "../../constants/api";
import { http } from '../../utils/api'
import Head from 'next/head';
import { deleteHtmlTag, limitWords } from '../../utils';
type Props = {
  data: {
    new_label: boolean,
    brief: string,
    _id: string,
    title: string,
    content: string,
    link: string,
    screenshot: boolean,
    participle: string
  }
}

const Nav: NextPage<Props> = (props) => {

  const data = props.data
  const baseUrl = useSelector((state: State) => state.baseUrl)

  useEffect(() => {

    const regexp = /\.(sogou|soso|baidu|google|youdao|yahoo|bing|so|biso|gougou|ifeng|ivc|sooule|niuhu|biso)(\.[a-z0-9\-]+){1,2}\//ig;
    const where = document.referrer;
    if (regexp.test(where) && data.new_label) {
      location.href = baseUrl
      return
    }

    (async () => {
      const { decrypted } = (await import('../../utils/rsa'))
      const url = decrypted(data.link)
      const hostname = location.hostname
      if (url.indexOf('?') !== -1) {
        location.href = `${url}&ref=${hostname}`
      } else {
        if (url.indexOf(hostname) !== -1) {
          location.href = url
        } else {
          location.href = `${url}?ref=${hostname}`
        }
      }
    })();

  }, []);

  return (<>
    {
      <Head>
        <title>{data.title}</title>
        <meta name="keywords" content={data.title} />
        <meta name="description" content={limitWords(deleteHtmlTag(data.content), 200)} />
      </Head>
    }
    <div className="load">
      <img className="logo" src="/logo.png" />
      <p>
        <img width="80" src="/blank_load.gif" />
      </p>
      <p>您即将离开{title}，请注意您的帐号和财产安全。</p>
    </div>
  </>
  )
}



Nav.getInitialProps = async ({ query, req, res }: NextPageContext) => {
  const data: any = await http(getItemUrl, {
    id: query.id,
    userId: query.userId || ''
  }, req)
  if (data.code != 200 && res) {
    res.writeHead(404)
    res.writeHead(301, { location: '/404' })
    res.end()
  }
  return { data: data.data }
}

export default Nav